import React from 'react';
import {
  MasonryEngineNode,
  MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import { OverviewPanel, OverviewPanelProps } from './overview-panel.component';

type OverviewPanelNode = MasonryEngineNode<'overviewPanel', OverviewPanelProps>;

export type OverviewPanelNodeRendererProps =
  MasonryEngineNodeRendererProps<OverviewPanelNode>;

export function OverviewPanelRenderer({
  items,
}: OverviewPanelNodeRendererProps) {
  return <OverviewPanel items={items} />;
}
